<script setup>
import { useQuasar } from 'quasar'
import useUser from '../../../store/user.store'
import UserUpdate from './Update.vue'
import UserCreate from './Create.vue'
import Table from '../../shared/Table.vue'
import { callApi } from '../../../utils'
import { useI18n } from "vue-i18n"
const { t } = useI18n()

const {
  userList,
  getUserList,
  loading,
  pagination,
  filterOptions
} = useUser()

const $q = useQuasar()

const columns = [
  { name: 'name', align: 'left', label: t("customer.name"), field: 'name' },
  { name: 'email', align: 'left', label: t("customer.email"), field: 'email' },
  { name: 'role', align: 'left', label: t("user.role"), field: 'role' },
  { name: 'date', align: 'left', label: t("user.date"), field: 'date' },
]

function paginate (props) {
  callApi([getUserList], {
    ...filterOptions.value,
    page: parseInt(props.pagination.page),
    "page-size": parseInt(props.pagination.rowsPerPage)
  }, $q, loading)
}

function showUpdate (_, row) {
  $q.dialog({
    component: UserUpdate,
    componentProps: { id: row._id }
  })
}

function createUser ( ){
  $q.dialog({
    component: UserCreate
  })
}

callApi([getUserList], {
  'page-size': parseInt(pagination.value.rowsPerPage)
}, $q, loading)
console.log("User list: ", userList);
</script>

<template lang='pug'>
.user-list
  Table(
    :title='t("menu.users")'
    :rows='userList'
    :loading='loading'
    :columns='columns'
    row-key='_id'
    v-model:pagination="pagination"
    @request="paginate"
    @row-click='showUpdate'
  )    
    template(v-slot:header='props')
      q-th(v-for="(col, index) in props.cols" :key="col.name")
        div {{ col.label }}

    template(v-slot:body="props")
      q-td(v-for="col in props.cols" :key="col.name")
        div(v-if="col.name==='role'")
          q-badge(rounded color='grey-8' :label='col.value.name ? col.value.name : "-"')
        div(v-else) 
          | {{ col.value }}
    //- template(v-slot:top-right)
    //-   q-btn.q-ml-sm(
    //-     :class=`$q.dark.isActive ? 'bg-grey-10' : 'bg-grey-4'`
    //-     label='Add user'
    //-     color='primary'
    //-     flat
    //-     @click='createUser'
    //-   )
</template>
